/* Papierschmiede: Kaufbox für normale Poster-Artikel (ersetzt Variantenwahl und Tepo).
   Größe und Rahmen wie im Customizer gewählt. Die Regeln sind die des Customizers
   (format-gruppen.ts, poster-rahmen.ts, kanon-format.ts), hier nur gelesen aus dem,
   was der Shop hat: Varianten des Produkts und Rahmenprodukte der Kollektion.
   Kein Rahmen im Shop zu einem Maß = keine Rahmenwahl, ohne Liste in diesem Code.

   Warenkorb: Poster und Rahmen als zwei Zeilen, verbunden über _ps_gruppe (Poster)
   und _ps_rahmen_zu (Rahmen), gezeigt als eine Position (ps-pd-warenkorbzeile). */
(() => {
  if (customElements.get('ps-kaufbox')) return;

  const DIN = { a0: [841, 1189], a1: [594, 841], a2: [420, 594], a3: [297, 420], a4: [210, 297], a5: [148, 210], a6: [105, 148] };
  const zahl = (s) => Number(String(s).replace(',', '.'));
  const schluessel = (b, h) => `${Math.min(Math.round(b), Math.round(h))}x${Math.max(Math.round(b), Math.round(h))}`;
  const DIN_SCHLUESSEL = new Set(Object.values(DIN).map(([b, h]) => schluessel(b, h)));
  const istDin = (k) => DIN_SCHLUESSEL.has(k);

  // Maß aus einem Text: „A4“, „21 x 29.7cm“, „30 × 40 cm“, „400x600“ (mm) → Schlüssel ohne Richtung
  function masseSchluessel(roh) {
    if (!roh) return null;
    const text = roh.trim().replace(/\s*\([^()]*\)$/, '').toLowerCase().replace(/×/g, 'x');
    const din = text.match(/^(?:din\s*)?(a[0-6])$/);
    if (din) return schluessel(...DIN[din[1]]);
    const mm = /\d\s*mm\b/.test(text);
    const wh = text.replace(/\s*(?:cm|mm)\b/g, '').trim().match(/^(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)$/);
    if (!wh) return null;
    const b = zahl(wh[1]);
    const h = zahl(wh[2]);
    if (!(b > 0 && h > 0)) return null;
    const faktor = mm || (b > 100 && h > 100) ? 1 : 10;
    return schluessel(b * faktor, h * faktor);
  }

  function mmVon(key) {
    return key.split('x').map(Number);
  }

  // Alle einzelnen Formate, die ein Rahmenprodukt nennt (Titel in Klammern, DIN im Titel, SKU-Muster)
  function formateDesRahmens(rahmen) {
    const gefunden = new Set();
    const merke = (s) => { const k = masseSchluessel(s); if (k) gefunden.add(k); };
    for (const m of rahmen.title.matchAll(/\(([^()]*)\)/g)) merke(m[1]);
    for (const m of rahmen.title.matchAll(/\b(?:DIN\s*)?(A[0-6])\b/gi)) merke(m[1]);
    for (const v of rahmen.variants) for (const m of (v.sku || '').matchAll(/_(a[0-6]|\d+x\d+)_/gi)) merke(m[1]);
    return gefunden;
  }

  // „2x A4 | 4x A5“ / „2xA3 + 4xA4“ → [{menge, key}] oder null (kein Set).
  // Ein Teil reicht, wenn der Titel damit beginnt („3x A4“: Set aus gleich großen Blättern, Xmas-Sets 16.10.2026).
  function setVon(text) {
    const teile = [];
    for (const m of String(text).matchAll(/(\d+)\s*x\s*(A[0-6]|\d+(?:[.,]\d+)?\s*x\s*\d+(?:[.,]\d+)?)/gi)) {
      const key = masseSchluessel(m[2].replace(/\s*cm\b/i, ''));
      if (key) teile.push({ menge: Number(m[1]), key });
    }
    return teile.length >= 2 || (teile.length === 1 && /^\s*\d+\s*x\s*/i.test(String(text))) ? teile : null;
  }
  const setSchluessel = (s) => s.map((t) => `${t.menge}:${t.key}`).sort().join('|');

  const FARBEN = ['schwarz', 'weiß', 'weiss', 'natur'];
  const farbRang = (titel) => {
    const i = FARBEN.findIndex((f) => titel.toLowerCase().includes(f));
    return i < 0 ? 9 : i === 2 ? 1 : i;
  };
  const norm = (s) => s.normalize('NFKC').toLocaleLowerCase('de').replace(/ß/g, 'ss').replace(/\s+/g, ' ').trim();
  const farbKey = (titel) => { const i = FARBEN.findIndex((f) => norm(titel).includes(f.replace('ß', 'ss'))); return i < 0 ? norm(titel) : i === 2 ? 'weiss' : FARBEN[i]; };

  const cm = (mm) => String(Math.round(mm) / 10).replace('.', ',');
  const massText = (key) => { const [b, h] = mmVon(key); return `${cm(b)} × ${cm(h)} cm`; };
  const dinName = (key) => { const e = Object.entries(DIN).find(([, [b, h]]) => schluessel(b, h) === key); return e ? e[0].toUpperCase() : null; };

  customElements.define('ps-kaufbox', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const o = { signal: this.abort.signal };
      let daten;
      try { daten = JSON.parse(this.querySelector('[data-ps-kb-data]').textContent); } catch (e) { return; }
      this.daten = daten;
      this.t = daten.t;
      this.root = this.querySelector('[data-ps-kb-root]');
      this.geld = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
      this.einzelRahmen = daten.frames.map((r) => ({ ...r, formate: formateDesRahmens(r) })).filter((r) => r.formate.size === 1 && !setVon(r.title));
      this.setRahmen = daten.setRahmen === false ? [] : daten.frames.map((r) => ({ ...r, set: setVon(r.title) })).filter((r) => r.set);
      this.groessen = daten.variants.map((v) => this.groesse(v)).sort((a, b) => a.flaeche - b.flaeche);
      this.istSet = this.groessen.length > 0 && this.groessen.every((g) => g.set);
      this.menge = 1;
      this.rahmenWahl = null;
      const url = Number(new URLSearchParams(location.search).get('variant'));
      const start = this.groessen.find((g) => g.v.id === url && g.v.available) || this.standard();
      this.wahl = start?.v.id ?? null;
      this.weitereOffen = false;
      this.render();
      this.root.addEventListener('change', (e) => {
        const f = e.target;
        if (f.name === 'ps-kb-groesse') this.setzeGroesse(Number(f.value));
        if (f.name === 'ps-kb-rahmen') { this.rahmenWahl = f.value === '' ? null : Number(f.value); this.render(f.name); }
      }, o);
      this.root.addEventListener('click', (e) => {
        if (e.target.closest('[data-ps-kb-weitere]')) { this.weitereOffen = !this.weitereOffen; this.render('weitere'); }
        const q = e.target.closest('[data-ps-kb-menge]');
        if (q) { this.menge = Math.min(99, Math.max(1, this.menge + Number(q.dataset.psKbMenge))); this.render('menge'); }
        if (e.target.closest('[data-ps-kb-kaufen]')) this.inDenWarenkorb();
        if (e.target.closest('[data-ps-kb-guide]')) document.getElementById('ps-map-sizes')?.showModal();
      }, o);
      this.root.addEventListener('input', (e) => {
        if (e.target.matches('[data-ps-kb-mengefeld]')) {
          const n = Math.min(99, Math.max(1, parseInt(e.target.value, 10) || 1));
          this.menge = n; this.aktualisiereSumme();
        }
      }, o);
    }

    disconnectedCallback() { this.abort?.abort(); }

    groesse(v) {
      const set = setVon(v.title);
      if (set) {
        const flaeche = set.reduce((s, t) => { const [b, h] = mmVon(t.key); return s + t.menge * b * h; }, 0);
        return { v, key: null, set, flaeche, label: set.map((s) => `${s.menge}× ${dinName(s.key) || massText(s.key)}`).join(' + ') };
      }
      const key = masseSchluessel(v.title);
      const [b, h] = key ? mmVon(key) : [0, 0];
      return { v, key, set: null, flaeche: b * h, label: key ? null : v.title };
    }

    gruppen() {
      const alle = this.groessen;
      if (this.istSet) return { sichtbar: alle, weitere: [], titel: '' };
      const linie = this.daten.linie;
      const weitere = alle.filter((g) => g.key && (linie === 'B' ? !istDin(g.key) : istDin(g.key)));
      const sichtbar = alle.filter((g) => !weitere.includes(g));
      if (!weitere.length || !sichtbar.length) return { sichtbar: alle, weitere: [], titel: '' };
      return { sichtbar, weitere, titel: linie === 'B' ? this.t.more : this.t.moreClassic };
    }

    standard() {
      const g = this.gruppen();
      return g.sichtbar.find((x) => x.v.available) || this.groessen.find((x) => x.v.available) || this.groessen[0];
    }

    aktuell() { return this.groessen.find((g) => g.v.id === this.wahl); }

    // Rahmenzeilen zur gewählten Größe: Einzelrahmen oder Set-Rahmen
    rahmenZeilen(g) {
      if (!g) return { zeilen: [], grund: 'none' };
      let produkt = null;
      let istSetRahmen = false;
      if (g.set) {
        const ziel = setSchluessel(g.set);
        produkt = this.setRahmen.find((r) => setSchluessel(r.set) === ziel) || null;
        istSetRahmen = !!produkt;
      } else if (g.key) {
        produkt = this.einzelRahmen.find((r) => r.formate.has(g.key)) || null;
      }
      if (!produkt) return { zeilen: [], grund: g.set ? 'set' : 'groesse' };
      const zeilen = [...produkt.variants]
        .sort((a, b) => farbRang(a.title) - farbRang(b.title))
        .map((v) => ({ v, titel: istSetRahmen ? `${this.t.setFrame} ${v.title.replace(/^(Echtholz|Holzrahmen)\s+/i, '')}` : v.title, set: istSetRahmen }));
      return { zeilen, grund: '', produkt, istSetRahmen };
    }

    // Ersparnis des Set-Rahmens gegenüber den Einzelrahmen derselben Farbe
    ersparnis(g, rahmenVariante) {
      if (!g?.set) return 0;
      const farbe = farbKey(rahmenVariante.title);
      let einzeln = 0;
      for (const t of g.set) {
        const r = this.einzelRahmen.find((x) => x.formate.has(t.key));
        const v = r?.variants.find((x) => farbKey(x.title) === farbe);
        if (!v) return 0;
        einzeln += t.menge * v.price;
      }
      return Math.max(0, einzeln - rahmenVariante.price);
    }

    setzeGroesse(id) {
      const alt = this.aktuell();
      const altRahmen = alt && this.rahmenWahl ? this.rahmenZeilen(alt).zeilen.find((z) => z.v.id === this.rahmenWahl) : null;
      this.wahl = id;
      const neu = this.aktuell();
      // gleiche Farbe in der neuen Größe, sonst ohne Rahmen
      this.rahmenWahl = null;
      if (altRahmen) {
        const passend = this.rahmenZeilen(neu).zeilen.find((z) => z.v.available && farbKey(z.v.title) === farbKey(altRahmen.v.title));
        this.rahmenWahl = passend ? passend.v.id : null;
      }
      if (neu && history.replaceState) {
        const u = new URL(location.href); u.searchParams.set('variant', String(id)); history.replaceState(null, '', u);
      }
      this.render('groesse');
    }

    preis(g, rahmen) {
      return ((g?.v.price || 0) + (rahmen?.price || 0)) * this.menge;
    }

    el(tag, attr = {}, ...kinder) {
      const e = document.createElement(tag);
      for (const [k, v] of Object.entries(attr)) {
        if (v === false || v == null) continue;
        if (k === 'class') e.className = v; else if (k === 'text') e.textContent = v; else e.setAttribute(k, v === true ? '' : v);
      }
      for (const k of kinder.flat()) if (k) e.append(k);
      return e;
    }

    groesseZeile(g, gruppenName) {
      const t = this.t;
      const din = g.key ? dinName(g.key) : null;
      const name = g.set ? g.label : din ? `${din}` : g.key ? massText(g.key) : g.label;
      const klein = !g.set && g.key && din ? massText(g.key) : '';
      const frei = g.v.available;
      const checked = g.v.id === this.wahl;
      const input = this.el('input', { type: 'radio', name: 'ps-kb-groesse', value: g.v.id, checked, disabled: !frei });
      return this.el('label', { class: 'ps-kb__opt' + (checked ? ' is-on' : '') + (frei ? '' : ' is-off') },
        input,
        this.el('span', { class: 'ps-kb__name' }, this.el('b', { text: name }), klein && this.el('small', { text: klein })),
        this.el('span', { class: 'ps-kb__price', text: frei ? this.geld.format(g.v.price / 100) : t.soldOut }));
    }

    rahmenZeile(zeile) {
      const t = this.t;
      const frei = zeile.v.available;
      const checked = this.rahmenWahl === zeile.v.id;
      const bild = zeile.v.image;
      return this.el('label', { class: 'ps-kb__opt' + (checked ? ' is-on' : '') + (frei ? '' : ' is-off') },
        this.el('input', { type: 'radio', name: 'ps-kb-rahmen', value: zeile.v.id, checked, disabled: !frei }),
        bild && this.el('img', { class: 'ps-kb__thumb', src: bild, alt: '', width: 44, height: 44, loading: 'lazy' }),
        this.el('span', { class: 'ps-kb__name' }, this.el('b', { text: zeile.titel })),
        this.el('span', { class: 'ps-kb__price', text: frei ? `+ ${this.geld.format(zeile.v.price / 100)}` : t.unavailable }));
    }

    render(fokus) {
      const t = this.t;
      const g = this.aktuell();
      const gr = this.gruppen();
      const uid = this.dataset.sectionId;
      const imWeiteren = gr.weitere.some((x) => x.v.id === this.wahl);
      const offen = this.weitereOffen || imWeiteren;
      const rz = this.rahmenZeilen(g);
      const rahmen = this.rahmenWahl ? rz.zeilen.find((z) => z.v.id === this.rahmenWahl)?.v : null;

      const groessenListe = this.el('div', { class: 'ps-kb__list', role: 'radiogroup', 'aria-labelledby': `ps-kb-h1-${uid}` }, gr.sichtbar.map((x) => this.groesseZeile(x)));
      const weitereBlock = gr.weitere.length ? [
        this.el('button', { type: 'button', class: 'ps-kb__more', 'data-ps-kb-weitere': true, 'aria-expanded': String(offen), 'aria-controls': `ps-kb-w-${uid}`, text: `${gr.titel} ${offen ? '−' : '+'}` }),
        this.el('div', { class: 'ps-kb__list', id: `ps-kb-w-${uid}`, role: 'radiogroup', 'aria-label': gr.titel, hidden: !offen }, gr.weitere.map((x) => this.groesseZeile(x)))
      ] : [];

      const keinRahmen = this.el('label', { class: 'ps-kb__opt' + (this.rahmenWahl == null ? ' is-on' : '') },
        this.el('input', { type: 'radio', name: 'ps-kb-rahmen', value: '', checked: this.rahmenWahl == null }),
        this.el('img', { class: 'ps-kb__thumb', src: this.daten.ohneRahmenBild, alt: '', width: 44, height: 44, loading: 'lazy' }),
        this.el('span', { class: 'ps-kb__name' }, this.el('b', { text: t.noFrame })),
        this.el('span', { class: 'ps-kb__price', text: '' }));

      let rahmenInhalt;
      if (rz.zeilen.length) {
        rahmenInhalt = [keinRahmen, ...rz.zeilen.map((z) => this.rahmenZeile(z))];
      } else {
        const text = rz.grund === 'set' ? t.noFrameSet : t.noFrameFor.replace('{{ format }}', g?.key ? (dinName(g.key) ? `DIN ${dinName(g.key)}` : massText(g.key)) : 'dieses Format');
        rahmenInhalt = [this.el('p', { class: 'ps-kb__hint', text })];
      }
      let hinweis = null;
      if (rz.istSetRahmen && rahmen) {
        const s = this.ersparnis(g, rahmen);
        hinweis = this.el('p', { class: 'ps-kb__hint ps-kb__hint--ok', text: `${t.setFrameNote}${s > 0 ? ' ' + t.saving.replace('{{ betrag }}', this.geld.format(s / 100)) : ''}` });
      } else if (rz.istSetRahmen) {
        hinweis = this.el('p', { class: 'ps-kb__hint', text: t.setFrameNote });
      }

      const guide = !this.istSet && document.getElementById('ps-map-sizes')
        ? this.el('button', { type: 'button', class: 'ps-kb__link', 'data-ps-kb-guide': true, text: t.sizeGuide }) : null;

      const frei = !!g?.v.available;
      this.root.replaceChildren(...[
        this.el('div', { class: 'ps-kb__head' }, this.el('h2', { class: 'ps-kb__h', id: `ps-kb-h1-${uid}`, text: t.size }), guide),
        groessenListe, ...weitereBlock,
        this.el('div', { class: 'ps-kb__head' }, this.el('h2', { class: 'ps-kb__h', id: `ps-kb-h2-${uid}`, text: t.frame })),
        this.el('div', { class: 'ps-kb__list', role: 'radiogroup', 'aria-labelledby': `ps-kb-h2-${uid}` }, rahmenInhalt),
        hinweis,
        this.el('div', { class: 'ps-kb__bar' },
          this.el('div', { class: 'ps-kb__qty' },
            this.el('button', { type: 'button', 'data-ps-kb-menge': '-1', 'aria-label': '−', text: '−' }),
            this.el('input', { type: 'number', min: 1, max: 99, value: this.menge, inputmode: 'numeric', 'aria-label': t.quantity, 'data-ps-kb-mengefeld': true }),
            this.el('button', { type: 'button', 'data-ps-kb-menge': '1', 'aria-label': '+', text: '+' })),
          this.el('div', { class: 'ps-kb__sum' }, this.el('span', { text: t.total }), this.el('strong', { 'data-ps-kb-summe': true, text: this.geld.format(this.preis(g, rahmen) / 100) }), this.el('small', { text: t.tax }))),
        this.el('button', { type: 'button', class: 'ps-map-button ps-kb__cta', 'data-ps-kb-kaufen': true, disabled: !frei, text: frei ? t.add : t.soldOut }),
        this.el('p', { class: 'ps-kb__status', role: 'status', 'aria-live': 'polite', 'data-ps-kb-status': true })
      ].filter(Boolean));
      this.aktuelleRahmenVariante = rahmen;
      if (fokus) {
        const ziel = fokus === 'menge' ? this.root.querySelector('[data-ps-kb-mengefeld]')
          : fokus === 'weitere' ? this.root.querySelector('[data-ps-kb-weitere]')
          : this.root.querySelector(`input[name="${fokus}"]:checked`);
        ziel?.focus();
      }
    }

    aktualisiereSumme() {
      const s = this.root.querySelector('[data-ps-kb-summe]');
      if (s) s.textContent = this.geld.format(this.preis(this.aktuell(), this.aktuelleRahmenVariante) / 100);
    }

    async inDenWarenkorb() {
      const t = this.t;
      const g = this.aktuell();
      const rahmen = this.aktuelleRahmenVariante;
      if (!g?.v.available) return;
      const knopf = this.root.querySelector('[data-ps-kb-kaufen]');
      const status = this.root.querySelector('[data-ps-kb-status]');
      knopf.disabled = true; knopf.textContent = t.adding; status.textContent = '';
      const code = `ps${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
      const items = [{ id: g.v.id, quantity: this.menge, ...(rahmen ? { properties: { _ps_gruppe: code } } : {}) }];
      if (rahmen) items.push({ id: rahmen.id, quantity: this.menge, properties: { _ps_rahmen_zu: code } });
      const mini = document.querySelector('mini-cart');
      const body = { items, sections_url: window.location.pathname };
      if (mini && typeof mini.getSectionsToRender === 'function') body.sections = mini.getSectionsToRender().map((s) => s.id).join(',');
      try {
        const antwort = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body)
        });
        const stand = await antwort.json();
        if (!antwort.ok || stand.status) throw new Error(stand.description || stand.message || t.error);
        if (mini && typeof mini.renderContents === 'function' && stand.sections) mini.renderContents(stand);
        else window.location.href = window.routes?.cart_url || '/cart';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.render();
      } catch (fehler) {
        this.render();
        const s = this.root.querySelector('[data-ps-kb-status]');
        if (s) s.textContent = fehler?.message || t.error;
      }
    }
  });
})();
